import React from "react"
import "./video.css"

const Video = ({ videoSrcURL, videoTitle, ...props }) => (
  <div className="video">
    <video autoPlay muted={true} loop>
      <source src={videoSrcURL} type="video/mp4"></source>
    </video>
  </div>
)
export default Video
